import { render } from "./ProductOptions.vue?vue&type=template&id=9f344336&scoped=true"
import script from "./ProductOptions.vue?vue&type=script&lang=js"
export * from "./ProductOptions.vue?vue&type=script&lang=js"

import "./ProductOptions.vue?vue&type=style&index=0&id=9f344336&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f344336"]])

export default __exports__